module.exports = __webpack_public_path__ + "img/openldap.ca5c1949.svg";